import countries from 'i18n-iso-countries';
import countriesEnLocale from 'i18n-iso-countries/langs/en.json';
import countriesEsLocale from 'i18n-iso-countries/langs/es.json';
import countriesHeLocale from 'i18n-iso-countries/langs/he.json';

import { EN_US_LOCALE, ES_MX_LOCALE, HE_IL_LOCALE, LOCALES } from '@/i18n';

type AppLocale = (typeof LOCALES)[number];

/** i18n-iso-countries ships one JSON per ISO 639-1 language code (`langs/{prefix}.json`). */
const localeDataByIso639Prefix = {
  en: countriesEnLocale,
  he: countriesHeLocale,
  es: countriesEsLocale
} as const;

type Iso639Prefix = keyof typeof localeDataByIso639Prefix;

/** Maps each supported UI locale to the language prefix of its `langs/*.json` file (e.g. `en-US` → `en`). */
const appLocaleToIso639Prefix: Record<AppLocale, Iso639Prefix> = {
  [EN_US_LOCALE]: 'en',
  [HE_IL_LOCALE]: 'he',
  [ES_MX_LOCALE]: 'es'
};

LOCALES.forEach(appLocale => {
  const prefix = appLocaleToIso639Prefix[appLocale];
  const localeData = localeDataByIso639Prefix[prefix];
  if (appLocale) {
    localeData.locale = appLocale.toLowerCase();
  }
  countries.registerLocale(localeData);
});

export default countries;
